import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=22d4e96c&"
import script from "@/controllers/ap/reconciliation/report/Report?vue&type=script&lang=ts&"
export * from "@/controllers/ap/reconciliation/report/Report?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports